import type { IconDefinition } from '../index.tsx';

export const iconTicket: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconTicket',
  icon: [
    16,
    16,
    [],
    '',
    'M16 2H0V6C1.10457 6 2 6.89543 2 8C2 9.10457 1.10457 10 0 10V14H16V10C14.8954 10 14 9.10457 14 8C14 6.89543 14.8954 6 16 6V2ZM8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
